import { onFind } from '@elements/init-modules-in-scope';
import './scripts/common';

let _config = window['_config'] || {};

function displayTables() {
    onFind('.dp-wrapper table', (table) => {
        table.style.display = 'table';
    });
}

if (document.readyState === "loading") {
    // Loading hasn't finished yet
    document.addEventListener("DOMContentLoaded", displayTables);
} else {
    // `DOMContentLoaded` has already fired
    displayTables();
}

import { startStimulusApp } from '@symfony/stimulus-bridge';
export const app = startStimulusApp(require.context(
    '@symfony/stimulus-bridge/lazy-controller-loader!./vue/views',
    true,
    /\.(j|t)sx?$/
));

import { registerVueControllerComponents } from '@symfony/ux-vue';
registerVueControllerComponents(require.context('./vue/views', true, /\.vue$/, 'lazy'));

// NEEDED IF YOU USE PINIA

import {createPinia} from 'pinia';
document.addEventListener('vue:before-mount', (event) => {
    const {
        app,
    } = event.detail;

    const pinia = createPinia()
    app.use(pinia);
});
